import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LossesDelaysScreen } from './LossesDelaysScreen';

interface LossesDelaysPageProps {
    onLogout: () => void;
}

export const LossesDelaysPage: React.FC<LossesDelaysPageProps> = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/home');
    };

    return (
        <LossesDelaysScreen onBack={handleBack} />
    );
};